export default "__VITE_ASSET__jb1PASvN__"